module.exports = __webpack_public_path__ + "static/media/icon-marketplace.0ce25747.svg";